(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('Automacao', Automacao);

  Automacao.$inject = ['$resource'];

  function Automacao ($resource) {
    return $resource(apiUrl + '/automation/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'PUT', params: {}, isArray: false },
      find: { method: 'GET', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: true }
    });
  }
})();
